<template>
  <div>
    <form name="TinkoffPayForm" ref="payForm">
      <input class="tinkoffPayRow" type="hidden" name="terminalkey" value="1595960688565">
      <input class="tinkoffPayRow" type="hidden" name="frame" value="true">
      <input class="tinkoffPayRow" type="hidden" name="language" value="ru">
      <input class="tinkoffPayRow" type="hidden" name="amount" value="100">
      <input class="tinkoffPayRow" type="hidden" name="order" :value="orderNumber">
      <input class="tinkoffPayRow" type="hidden" name="successUrl" value="http://localhost:8080/">
      <input class="tinkoffPayRow" type="hidden" name="description" value="Регистрация цифрового отпечатка файла">
      <input class="tinkoffPayRow" type="hidden" name="email" :value="registrationData.email">
      <input class="tinkoffPayRow" type="hidden" name="receipt" :value=getReceipt>
      <v-btn type="submit" @click.prevent="registerDocument" block color="success" class="mt-5" :disabled="disabled" id="submitbutton"><!-- !toRegister || !emailIsValid -->
        <span class="text-wrap">
          Зарегистрировать файл в системе AVISHASH
        </span>
      </v-btn>
    </form>
    <DemoRegistration :dialogDemo="dialogDemo" v-if="orderNumber" :orderNumber="orderNumber"/>
  </div>
</template>
<script>
import DemoRegistration from './DemoRegistration.vue'
import { usePathFromBaseURI } from '../infrastructure/api/endpoints'
import { httpClient } from '../infrastructure/api/config'
export default {
  name: 'DemoDocumentRegistrationForm',
  props: {
    disabled: {
      type: Boolean,
      required: true,
    },
    registrationData: {
      type: Object,
      required: true,
    },
  },
  components: {
    DemoRegistration,
  },
  data: () => ({
    dialogDemo: false,
  }),
  computed: {
    email() {
      return this.registrationData.email
    },
    orderNumber() {
      return this.registrationData.DocID
    },
    getReceipt() {
      let receipt = {
        "Email": this.email,
        "Taxation": "usn_income",
        "Items": [
          {
            "Name": "Регистрация цифрового отпечатка файла",
            "Price": 10000,
            "Quantity": 1.00,
            "Amount": 10000,
            "Tax": "none"
          },
        ]
      }
      return JSON.stringify(receipt)
    }
  },
  methods: {
    async registerDocument() {
      this.$emit('start-loading')
      try {
        const endpoint = usePathFromBaseURI('api', 'Payments', 'demo')
        await httpClient.post(endpoint.href, { ...this.registrationData, ServiceName: 'DEMO' }) // , externalSystemId: 'a7c574d3-6d75-48d6-98f1-3e92bdaf4d5d'
        this.dialogDemo = true
      } catch(err) {
        this.$emit('registration-failed', err)
      } finally {
        this.$emit('finish-loading')
      }
    },
  },
}
</script>